function getLensProductVariantName(lensProduct) {
    var ref, ref1;
    if (!(lensProduct === null || lensProduct === void 0 ? void 0 : (ref = lensProduct.variants) === null || ref === void 0 ? void 0 : ref.length)) {
        return;
    }
    const selected = (ref1 = lensProduct.variants) === null || ref1 === void 0 ? void 0 : ref1.find((v)=>v.sku === lensProduct.sku
    );
    const title = selected === null || selected === void 0 ? void 0 : selected.title;
    return title || undefined;
}

export { getLensProductVariantName };
//# sourceMappingURL=get-lens-product-variant-name.js.map
